import {FreeSpinsInfoModule} from '@fantasmagames/slot/src/modules/freespins/info/FreeSpinsInfoModule';
import {RecodeLogic} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';

export class GameFreeSpinsInfoModule extends FreeSpinsInfoModule {
	public restore(): void {
		const logic: RecodeLogic = this.logic as RecodeLogic;

		if (logic.isFreeSpinsStarted && logic.freeSpinsPlayed > 0) {
			this.view.show();
			this.updateSpinsLeftOnRestore();
		}
	}

	protected updateSpinsLeftOnRestore(): void {
		this.view.setRemainingFreeSpins(this.logic.freespinsTotalAwarded, this.logic.freeSpinsPlayed);
	}
}



// WEBPACK FOOTER //
// ./src/freespins/info/GameFreeSpinsInfoModule.ts